var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoArea"},[_c('h2',[_vm._v("お知らせ")]),_c('a',{staticClass:"buttonList",attrs:{"href":"/information/"}},[_vm._v("一覧を見る")]),_c('div',{staticClass:"infoBox"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.infoHtml)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }